export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/11892e83d50800d3abe81cea56c314af2e9031cb/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"